/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactFromJSON, ContactToJSON, LocalAccountTypesFromJSON, LocalAccountTypesToJSON, UserOrderTimerFromJSON, UserOrderTimerToJSON, WorkerFromJSON, WorkerToJSON, } from './';
export function UserFromJSON(json) {
    return UserFromJSONTyped(json, false);
}
export function UserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'contactId': !exists(json, 'contactId') ? undefined : json['contactId'],
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'workerVendor': !exists(json, 'workerVendor') ? undefined : json['workerVendor'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'loginName': !exists(json, 'loginName') ? undefined : json['loginName'],
        'properNameDisplay': !exists(json, 'properNameDisplay') ? undefined : json['properNameDisplay'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
        'localAccountFlag': !exists(json, 'localAccountFlag') ? undefined : LocalAccountTypesFromJSON(json['localAccountFlag']),
        'assignToSecure': !exists(json, 'assignToSecure') ? undefined : json['assignToSecure'],
        'userRole': !exists(json, 'userRole') ? undefined : json['userRole'],
        'cUserCanDos': !exists(json, 'cUserCanDos') ? undefined : json['cUserCanDos'],
        'cUserCanDoQualifiers': !exists(json, 'cUserCanDoQualifiers') ? undefined : json['cUserCanDoQualifiers'],
        'resourceOwnerTransitoryTag': !exists(json, 'resourceOwnerTransitoryTag') ? undefined : json['resourceOwnerTransitoryTag'],
        'resetPasswordRequestTag': !exists(json, 'resetPasswordRequestTag') ? undefined : json['resetPasswordRequestTag'],
        'mustChangePasswordNextLogon': !exists(json, 'mustChangePasswordNextLogon') ? undefined : json['mustChangePasswordNextLogon'],
        'cannotChangePassword': !exists(json, 'cannotChangePassword') ? undefined : json['cannotChangePassword'],
        'isDisabled': !exists(json, 'isDisabled') ? undefined : json['isDisabled'],
        'orderTimer': !exists(json, 'orderTimer') ? undefined : UserOrderTimerFromJSON(json['orderTimer']),
        'inOutStatus': !exists(json, 'inOutStatus') ? undefined : json['inOutStatus'],
        'inOutDateTime': !exists(json, 'inOutDateTime') ? undefined : (json['inOutDateTime'] === null ? null : new Date(json['inOutDateTime'])),
        'inOutActiveFlag': !exists(json, 'inOutActiveFlag') ? undefined : json['inOutActiveFlag'],
        'contact': !exists(json, 'contact') ? undefined : ContactFromJSON(json['contact']),
        'worker': !exists(json, 'worker') ? undefined : WorkerFromJSON(json['worker']),
        'propertyIds': !exists(json, 'propertyIds') ? undefined : json['propertyIds'],
        'lastLoginDate': !exists(json, 'lastLoginDate') ? undefined : (json['lastLoginDate'] === null ? null : new Date(json['lastLoginDate'])),
    };
}
export function UserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'userId': value.userId,
        'contactId': value.contactId,
        'subjectId': value.subjectId,
        'workerVendor': value.workerVendor,
        'propertyId': value.propertyId,
        'loginName': value.loginName,
        'properNameDisplay': value.properNameDisplay,
        'emailAddress': value.emailAddress,
        'localAccountFlag': LocalAccountTypesToJSON(value.localAccountFlag),
        'assignToSecure': value.assignToSecure,
        'userRole': value.userRole,
        'cUserCanDos': value.cUserCanDos,
        'cUserCanDoQualifiers': value.cUserCanDoQualifiers,
        'resourceOwnerTransitoryTag': value.resourceOwnerTransitoryTag,
        'resetPasswordRequestTag': value.resetPasswordRequestTag,
        'mustChangePasswordNextLogon': value.mustChangePasswordNextLogon,
        'cannotChangePassword': value.cannotChangePassword,
        'isDisabled': value.isDisabled,
        'orderTimer': UserOrderTimerToJSON(value.orderTimer),
        'inOutStatus': value.inOutStatus,
        'inOutDateTime': value.inOutDateTime === undefined ? undefined : (value.inOutDateTime === null ? null : value.inOutDateTime.toISOString()),
        'inOutActiveFlag': value.inOutActiveFlag,
        'contact': ContactToJSON(value.contact),
        'worker': WorkerToJSON(value.worker),
        'lastLoginDate': value.lastLoginDate === undefined ? undefined : (value.lastLoginDate === null ? null : value.lastLoginDate.toISOString()),
    };
}
